import './App.css';

import Cadastro from "./components/Cadastro"


function App() {
  return (
    <div className="row">
      <div className='col-md-8 offset-md-2'>
        <Cadastro />
      </div>
    </div>
  );
}

export default App;
